// extracted by mini-css-extract-plugin
export default {"header":"styles_header__ANJcp","content":"styles_content__W4WwF","datesCouple":"styles_datesCouple__3QWja","buttonWrapper":"styles_buttonWrapper__B80dm","icon":"styles_icon__0fpP4"};